// Silent thumbnail self-heal. Deduped per (context, assetId) for the tab's lifetime
// so a broken image doesn't hammer the backend if the heal call itself fails or
// the image keeps erroring after the URL rotation.
import api from "@/lib/api";

const healed = new Set();

/** Admin/authed context — hits the existing refresh-status endpoint. */
export function healAssetThumbnail(assetId, onFresh) {
  if (!assetId) return;
  const key = `admin:${assetId}`;
  if (healed.has(key)) return;
  healed.add(key);
  api.post(`/assets/${assetId}/refresh-status`)
    .then((r) => { if (r?.data?.thumbnail_url && onFresh) onFresh(r.data.thumbnail_url); })
    .catch(() => { /* silent — dedupe still holds */ });
}

/** Public share context — hits the share heal endpoint. */
export function healShareThumbnail(slug, assetId, shareToken, onFresh) {
  if (!slug || !assetId) return;
  const key = `share:${slug}:${assetId}`;
  if (healed.has(key)) return;
  healed.add(key);
  const params = shareToken ? { token: shareToken } : {};
  api.post(`/share/${slug}/assets/${assetId}/heal-thumbnail`, null, { params })
    .then((r) => { if (r?.data?.thumbnail_url && onFresh) onFresh(r.data.thumbnail_url); })
    .catch(() => { /* silent */ });
}
